var map = {
	"./BerkleyRe_logo.png": 911,
	"./Lloyds_logo.png": 7599,
	"./Swiss_Re_logo.png": 4671,
	"./arrow.png": 1733,
	"./care-liability.png": 4378,
	"./construction.png": 2420,
	"./cyber.png": 2037,
	"./general-liability.png": 7817,
	"./hero_bg.png": 3612,
	"./hospitality.png": 2227,
	"./logo.png": 7591,
	"./nav-menu.png": 2379,
	"./navbar-bg.png": 2421,
	"./professional-indemnity.png": 4673,
	"./property.png": 9634,
	"./provider.png": 6400,
	"./sample.png": 5881,
	"./side-banner.png": 1027,
	"./transport.png": 3773,
	"./user.png": 8152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;